<template>
<div @click="resultSelected" @mouseover="overImage" @mouseout="outImage" :class="['wrapper', {'over': over}, {'withId': withId()}]" >
    <transition name="gallery-fade">
      <div class="inner-wrapper" v-show="loaded">
        <div class="image-wrapper">
          <!-- <img class="image" :src="src" v-on:load="onLoaded"> -->
          <iframe class="image-iframe" scrolling="no" :srcdoc="src" @load.once="imageIframeLoaded" />
          <transition name="gallery-fade">
            <div class="overImage" v-show="over">
              <div class="text">
                <span v-if="externalUrlColumn !== ''" class="see">{{ $ml.get('see') }}</span>
                <span v-else-if="idColumn !== ''" class="edit">{{ $ml.get('edit') }}</span>
              </div>
            </div>
          </transition>
          <div if="withLangLegend" class="lang-legend">
            <span>{{ getLangCode() }}</span>
          </div>
        </div>
        <span class="name">{{ name }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
import * as appTypes from '@/store/actions/app'

export default {
  name: 'searcher-gallery-image',
  props: [
    'idColumn',
    'externalUrlColumn',
    'src',
    'name',
    'withLangLegend',
    'idValue'
  ],
  data () {
    return {
      loaded: false,
      over: false
    }
  },
  methods: {
    onLoaded () {
      this.loaded = true
    },
    resultSelected () {
      this.$emit('resultSelected')
    },
    overImage () {
      if (this.withId()) {
        this.over = true
      }
    },
    outImage () {
      if (this.withId()) {
        this.over = false
      }
    },
    getLangCode () {
      return this.$ml.get('isoCode').substr(0, 2).toUpperCase()
    },
    withId () {
      return this.idValue && this.idValue !== ''
    },
    imageIframeLoaded (event) {
      let doc = event.target.contentWindow.document
      if (doc.body) {
        if (!this.editable) {
          doc.body.style.zoom = '60%'
        }
      }
      this.loaded = true

      let generalSidebar = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_GENERAL_SIDEBAR}`]
      if (generalSidebar) {
        generalSidebar.el.style.width = generalSidebar.el.offsetWidth - 1 + 'px'
        this.$nextTick(() => {
          setTimeout(() => {
            generalSidebar.recalculate()
            generalSidebar.el.style.width = generalSidebar.el.offsetWidth + 1 + 'px'
          }, 100)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: center;
  margin-top: 25px;
  margin-bottom: 5px;
  width: 20%;
  display: inline-block;
  vertical-align: top;

  &.withId {
    cursor: pointer;
  }

  .inner-wrapper {
    padding: 10px 0 8px;
    background-color: #f9f9f9;
    margin: 0 15px;
    border: 1.5px solid #333;
    transition: background-color 0.2s ease-in-out;

    .image-wrapper {
      min-height: 500px;
      max-height: 500px;
      overflow: hidden;
      position: relative;
      margin: 0 10px;
      transition: background-color 0.2s ease-in-out;

      .image-iframe {
        border: 0;
        width: 100%;
        height: 500px;
      }

      .overImage {
        position: absolute;
        background-color: rgba(0,0,0,0.8);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        .text {
          position: absolute;
          top: 50%;
          margin-top: -15px;
          text-align: center;
          left: 0;
          right: 0;
          transition: margin-top 0.2s ease-in-out;

          span {
            padding: 6px 22px 7px;
            color: #fff;
            text-transform: uppercase;
            background-color: #d42e12;
            font-size: 16px;
            font-family: "Source Sans Pro", sans-serif;
          }
        }
      }

      .lang-legend {
        color: #d42e12;
        text-transform: uppercase;
        font-size: 14px;
        border-radius: 3px;
        font-family: "Source Sans Pro", sans-serif;
        background: linear-gradient(to bottom right, transparent 0%, transparent 50%, #d9d9d9 50%, #d9d9d9 100%);
        width: 45px;
        position: absolute;
        bottom: 0;
        right: 0;
        height: 45px;
        overflow: hidden;
        display: none;

        span {
          transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
          display: inline-block;
          position: absolute;
          bottom: 4px;
          right: 5px;
        }
      }
    }

    .name {
      display: block;
      text-align: left;
      font-size: 18px;
      color: #fff;
      padding: 6px 0 8px;
      margin: 8px 10px 0;
      font-family: "Source Sans Pro", sans-serif;
      text-align: center;
      background-color: #333;
      transition: background-color 0.2s ease-in-out;
    }
  }

  &.over {
    .inner-wrapper {
      border: 1.5px solid #d42e12;
    }
  }
}
.horizontal {
  .wrapper {
    .inner-wrapper {
      .image-wrapper {
        min-height: 200px;
        max-height: 200px;

        img {
          width: 55%;
        }
      }
    }
  }
}
.gallery-fade-enter-active {
  transition: all 0.2s ease-in-out;
}
.gallery-fade-enter-to {
  opacity: 1;
}
.gallery-fade-enter {
  opacity: 0;

  .text {
    margin-top: -35px !important;
  }
}
</style>
